import { IconClockLine, Text } from "@instructure/ui";
import { t } from "i18next";

const TimeoutBody = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <IconClockLine color="warning" size="medium" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.timeoutBody")}
      </Text>
    </div>
  );
};

export default TimeoutBody;
